import MaterialExTable from "../../../../components/tables/MaterialExTable";
import useGetEmailLogsDetails from "../../../Utilities/EmailRecipientConfiguration/EmailLogs/hooks/useEmailLogsDetails";
const EmailLogsModalTable = (emailLogsDetails, setemailLogsDetails) => {
  const { data: logsDetails } = useGetEmailLogsDetails(
    emailLogsDetails.emailLogsDetails?.id
  );
  const matColumns = [
    {
      title: "Message",
      field: "message",
      render: (rowData) => {
        return <>{rowData.message}</>;
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => {
        return (
          <>
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : "unspecified"}
          </>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      render: (rowData) => {
        return <>{rowData.createdBy}</>;
      },
    },
  ];

  return (
    <div className="animate-fade-in-down space-y-5">
      <div className="hb-2 font-bold text-primary text-xl mx-4 pt-2">
        <div className="text-base">Email Logs Details</div>
        <div className="w-full">
          <div className="rounded-md pt-4 pb-4">
            <MaterialExTable columns={matColumns} data={logsDetails} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmailLogsModalTable;
